<template>
    <div>
        <slot></slot>
    </div>
</template>
<script>
    import $ from 'jquery';
    import Slick from 'vue-slick';

    export default {
        extends: Slick,

        destroyed: function() {
            const $slick = $(this.$el);
            $slick.next('.paging').remove();
        },

        methods: {
            create: function() {
                const $slick = $(this.$el);

                $slick.on('afterChange', this.onAfterChange);
                $slick.on('beforeChange', this.onBeforeChange);
                $slick.on('breakpoint', this.onBreakpoint);
                $slick.on('destroy', this.onDestroy);
                $slick.on('edge', this.onEdge);
                $slick.on('init', this.onInit);
                $slick.on('reInit', this.onReInit);
                $slick.on('setPosition', this.onSetPosition);
                $slick.on('swipe', this.onSwipe);
                $slick.on('lazyLoaded', this.onLazyLoaded);
                $slick.on('lazyLoadError', this.onLazyLoadError);

                // remove any existing paging element
                $slick.next('.paging').remove();

                // ensure one is added
                $slick.after('<div class="paging" />');

                // create carousel
                $slick.slick(this.options);
            }
        }
    }
</script>